import gql from 'graphql-tag';

export const paymentMethodFragment = gql`{
  id
  
}`
